import "./ContactForm.css";

export default function ContactForm() {
  return (
    <section className="contact-card" aria-labelledby="contact-form-heading">
      <h2 id="contact-form-heading" className="contact-title">Contact Us</h2>

      <div className="form-grid">
        <form action="https://formspree.io/f/mldqkgbo" method="POST" className="contact-form">
          <label className="form-field">
            <span className="form-label">Your Email</span>
            <input type="email" name="email" className="inputEmail" required />
          </label>

          <label className="form-field">
            <span className="form-label">Your Inquiry</span>
            <textarea name="message" className="inputArea" rows="6" required></textarea>
          </label>
          <div className="form-actions">
            <button type="submit" className="sendButton">Submit&nbsp;&nbsp;<i className="fa fa-paper-plane" aria-hidden="true"></i></button>
          </div>
        </form>
      </div>
    </section>
  );
}
